// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-location-w) {
  height: calc(100vh - 288px);
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.saverow {
  height: 44px;
  min-height: 44px !important;
  align-items: center;
}

.content-area {
  height: calc(100vh - 288px);
  margin-bottom: 1%;
  margin-right: 36.55px;
  overflow-y: hidden;
  overflow-x: hidden;
}

.detail-form {
  height: 100%;
  overflow-x: hidden;
}

.remove-button {
  margin-left: 10px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
}

.active-heading {
  color: var(--theme-main-color, #055C8D);
}

.sidebar {
  mix-blend-mode: normal;
  background-color: rgba(234, 234, 234, 0.29);
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.map {
  margin-right: 10px;
}

.map-row {
  min-height: 50vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.remove-button {
  margin-left: 10px;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
